export const environment = {
  production: false,
  apiUrl: 'https://ln-admin-api-dev-obbsjbngaa-uc.a.run.app',
  firebase: {
    apiKey: 'AIzaSyD8YNaTv512Ev6dlqNwomDx5PUjQbnX8xI',
    authDomain: 'amd-1is9pqhrhk3pg0wlf1.firebaseapp.com'
  },
  // OIDC provider id as configured in this project's Firebase
  // Authentication > Sign-in method console. Per-project; must keep the `oidc.` prefix.
  oktaProviderId: 'oidc.okta',
  // Deployed environments are Okta-only; password sign-in is for local development only.
  // CAVEAT: this flag only hides the UI. Local development shares this same Firebase project
  // (amd-1is9pqhrhk3pg0wlf1), so the Email/Password provider must stay ENABLED here for local to
  // work - meaning it stays reachable on deployed dev via the public web API key regardless of this
  // flag. Closing that requires pointing local at the auth emulator (or its own project) so
  // Email/Password can be disabled in this project outright.
  allowPasswordSignIn: false
};
